
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/aiDevelopment",
      function () {
        return require("private-next-pages/visitor/aiDevelopment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/aiDevelopment"])
      });
    }
  